import { FetchLegalEntitiesDocument, FetchLegalEntitiesQuery } from 'generated/resources/graphql'
import uniqBy from 'lodash/uniqBy'

import { useQuery } from 'modules/core/hooks/useQuery'

export type LegalEntity =
  FetchLegalEntitiesQuery['companies']['legalEntitiesConnection']['nodes'][number]

type Props = {
  employeesIds?: string[]
}

export type UniqueLegalEntities = {
  id: string
  legalName?: string | null | undefined
}[]

const useLegalEntities = ({ employeesIds }: Props) => {
  const { data, loading } = useQuery(FetchLegalEntitiesDocument, {
    variables: { employeesIds },
  })
  const nodes = data?.companies?.legalEntitiesConnection.nodes ?? []
  const uniqueLegalEntities = uniqBy(nodes, 'id')

  return {
    legalEntities: uniqueLegalEntities,
    loading,
  }
}

export default useLegalEntities
